import { render, staticRenderFns } from "./GridSeoConfigs.vue?vue&type=template&id=733361e1&"
import script from "./GridSeoConfigs.vue?vue&type=script&lang=js&"
export * from "./GridSeoConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733361e1')) {
      api.createRecord('733361e1', component.options)
    } else {
      api.reload('733361e1', component.options)
    }
    module.hot.accept("./GridSeoConfigs.vue?vue&type=template&id=733361e1&", function () {
      api.rerender('733361e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/seo-configs/grid/GridSeoConfigs.vue"
export default component.exports